type Props = {
  label: string;
  value: string;
  onChange: (v: string) => void;
  type?: string | undefined;
  placeholder?: string | undefined;
  error?: string | undefined;
  /** Small helper text shown under the input (e.g. expected format). */
  hint?: string | undefined;
  /** Mobile keyboard hint — 'tel' / 'numeric' / 'email' etc. */
  inputMode?:
    | 'text'
    | 'tel'
    | 'numeric'
    | 'email'
    | 'decimal'
    | 'search'
    | 'url'
    | undefined;
  /** Browser autofill token — 'tel', 'email', 'given-name', etc. */
  autoComplete?: string | undefined;
  min?: number | undefined;
  max?: number | undefined;
  step?: number | undefined;
};

export function Field({
  label,
  value,
  onChange,
  type = 'text',
  placeholder = '',
  error,
  hint,
  inputMode,
  autoComplete,
  min,
  max,
  step,
}: Props) {
  return (
    <div className={`mtc-field ${error ? 'has-error' : ''}`}>
      <label>{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        inputMode={inputMode}
        autoComplete={autoComplete}
        min={min}
        max={max}
        step={step}
      />
      {hint && !error && <span className="mtc-field-hint">{hint}</span>}
      {error && <span className="mtc-field-err">{error}</span>}
    </div>
  );
}
